import {
  Button,
  Card,
  CardContent,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";

export default function EFormStatus() {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <Grid item container>
      <Button href="/familyquestionnairessummary" startIcon={<ArrowBackIos />}>
        Back to Family Questionnaires Summary
      </Button>
      <Card
        sx={{
          width: "100%",
          backgroundColor: "myVerify.light",
          boxShadow: "0 16px #3E7787",
          marginBottom: 4,
          marginTop: 2,
        }}
      >
        <CardContent>
          <Grid
            item
            xs={10}
            sm={10}
            md={11}
            display="block"
            flexDirection="column"
            paddingLeft={3}
          >
            <Typography variant="h6" fontWeight={700} marginBottom={1}>
              Online Form
            </Typography>
            <Typography display={isMobile ? "none" : "show"} marginBottom={1}>
              <span style={{ fontWeight: 700 }}>Note to Candidate: </span>
              Once you have distributed and collected your Family Questionnaires
              complete this Summary Sheet.
            </Typography>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}
